/**
 * @desc 列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ProcurementOrderRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
